<template>
  <div id="o-que-fazemos" class="services">
    <section class="container">
      <h1>O que fazemos</h1>
      <p>Somos uma consultoria que visa à inserção da pessoa com deficiência (PCD) nas empresas de forma responsável, zelando pelo profissionais com deficiência e buscando inserí-los no mercado de trabalho em cargos que suas habilidades e competências sejam compatíveis com o perfil profissional. Nossos serviços incluem:</p>
    </section>
    <section class="container">

      <aside class="boxs">
        <b-container>
            <b-row>
                <b-col class="box-blue col-sm-12 col-xs-12 col-md-6 col-lg-3">
                  <img src="../assets/img/analise-de-acessibilidade.png">
                  <p>Análise de acessibilidade e mapeamento de postos</p>
                </b-col>

                <b-col class="box-blue col-sm-12 col-xs-12 col-md-6 col-lg-3">
                  <img src="../assets/img/recrutamento-e-selecao.png">
                  <p>Recrutamento e Seleção</p>
                </b-col>

                <b-col class="box-blue col-sm-12 col-xs-12 col-md-6 col-lg-3">
                  <img src="../assets/img/sensibilizacao-das-equipes.png">
                  <p>Sensibilização das equipes</p>
                </b-col>

                <b-col class="box-blue col-sm-12 col-xs-12 col-md-6 col-lg-3">
                  <img src="../assets/img/consultoria.png">
                  <p>Consultoria constante para a pessoa-chave de Recursos Humanos</p>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="box-blue col-sm-12 col-xs-12 col-md-6 col-lg-3">
                  <img src="../assets/img/icon-roda-da-conversa.png">
                  <p>Roda de conversa</p>
                </b-col>

                <b-col class="box-blue col-sm-12 col-xs-12 col-md-6 col-lg-3">
                  <img src="../assets/img/icon-assessoria.png">
                  <p>Assessoria a colaboradores com deficiência</p>
                </b-col>

                <b-col class="box-blue col-sm-12 col-xs-12 col-md-6 col-lg-3">
                  <img src="../assets/img/assessoria-aos-gestores.png">
                  <p>Assessoria aos gestores com colaboradores com deficiência (presencial e online)</p>
                </b-col>

                <b-col class="box-blue col-sm-12 col-xs-12 col-md-6 col-lg-3">
                  <img src="../assets/img/treinamento-para-equipe.png">
                  <p>Treinamento para a equipe de Comunicação e Marketing</p>
                </b-col>
            </b-row>
        </b-container>
      </aside>

      <div class="btn-center">
        <a href="#" class="btn-white">Conheça todos os nossos serviços</a>
      </div>

    </section>
  </div>
</template>

<script>
export default {
  name: 'Banner',
  data () {
    return {
      msg: 'Incluir da Certo'
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~styles/_bootstrap-variables";
  @import "~styles/_mixin-buttons";
  @import "~styles/_main";
  @import "~styles/_services";
</style>



// WEBPACK FOOTER //
// src/components/Services.vue